import { addSheetBackLink, PARENT_SHEETS } from "../sheetNavigation";
import {
  COL_D,
  COL_E,
  COL_F,
  COL_G,
  HEADER_FILL,
  TABLE_HEADER_FILL,
  mergeRow,
  safeText,
  setCell,
} from "./principle6SheetHelpers";
import { filterPopulatedRows, setStandardDetailWidths } from "./principle8SheetHelpers";

const TITLE_ROW = 3;
const HEADER_ROW = 4;
const DATA_START_ROW = 5;

export const SHEET_NAME = "Details of corrective action IP";

const SHEET_TITLE =
  "Details of corrective actions taken or underway, based on any adverse order in intellectual property related disputes wherein usage of traditional knowledge is involved.";

export function buildDetailsOfCorrectiveActionIPSheet(workbook, sectionC) {
  const ws = workbook.addWorksheet(SHEET_NAME, { views: [{ showGridLines: true }] });
  setStandardDetailWidths(ws, { D: 8, E: 20, F: 24, G: 24 });

  const rows = filterPopulatedRows(
    sectionC?.principle8?.leadershipIndicator?.correctiveActionsForAdverseOrders,
    ["authorityName", "caseBrief", "correctiveActionTaken"]
  );

  addSheetBackLink(ws, PARENT_SHEETS.PRINCIPLE_8, { mergeEnd: COL_G });

  mergeRow(ws, TITLE_ROW, COL_D, COL_G, SHEET_TITLE, {
    bold: true,
    fill: HEADER_FILL,
    align: "center",
  });

  setCell(ws, HEADER_ROW, COL_D, "Sr.No.", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_E, "Name of authority", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_F, "Brief of the Case", { bold: true, fill: TABLE_HEADER_FILL, align: "center" });
  setCell(ws, HEADER_ROW, COL_G, "Corrective action taken", {
    bold: true,
    fill: TABLE_HEADER_FILL,
    align: "center",
  });

  rows.forEach((item, idx) => {
    const row = DATA_START_ROW + idx;
    setCell(ws, row, COL_D, String(idx + 1), { align: "center" });
    setCell(ws, row, COL_E, safeText(item?.authorityName), { align: "left" });
    setCell(ws, row, COL_F, safeText(item?.caseBrief), { align: "left" });
    setCell(ws, row, COL_G, safeText(item?.correctiveActionTaken), { align: "left" });
  });

  return ws;
}
